import { useEffect } from 'react';
import { useSocket } from '../context/SocketContext';

/** Join / leave a route room for live GPS updates. */
export function useSocketRoute(routeId) {
  const { socket, isConnected } = useSocket();

  useEffect(() => {
    if (!socket || !isConnected || !routeId) return undefined;

    socket.emit('join_route', { routeId });
    return () => {
      socket.emit('leave_route', { routeId });
    };
  }, [socket, isConnected, routeId]);
}
